import { Component, OnInit, inject } from '@angular/core';
import { NgDocThemeService } from '@ng-doc/app';

@Component({
  selector: 'app-error-view',
  standalone: true,
  imports: [],
  templateUrl: './error-view.component.html',
  styleUrl: './error-view.component.scss'
})
export class ErrorViewComponent implements OnInit {
  currentTheme: any;
  errorImage: string = '';
  private readonly themeService= inject(NgDocThemeService);

  ngOnInit(): void {
    this.setImage();
    this.themeService.themeChanges().subscribe(() => {
      this.setImage();
    });
  }


  isDarkTheme(): boolean {
    return this.currentTheme.id === 'acium-dark';
  }

  setImage(){
    this.currentTheme = this.themeService.currentTheme;
    this.errorImage = this.isDarkTheme() ? 'assets/img/error-dark-mode.png' : 'assets/img/error-light-mode.png';
  }
}
